<script lang="ts">
import { page } from '$app/stores'
import PageNotFound404 from '$components/Global/PageNotFound404.svelte'

const error = $page.error?.message

$: console.log(`Page load error: ${error}`)
</script>

<div style="padding:10px;">
  <PageNotFound404 />
</div>

<slot />
